





















import { ExActAndConfigCouponInfo } from '@/types/coupon';
import { FitHalfScreenDialogV2 } from '@tencent/wphk-ui';
import { defineComponent, nextTick, PropType, ref } from '@vue/composition-api';
import SvgIcon from '@/components/common/svg-icon.vue';
import { getTncConfigContent } from '@/business/format-tnc';
import TncSkeleton from '@/components/common/skeleton/tnc-skeleton.vue';

export default defineComponent({
  name: 'TncDialog',
  components: {
    HalfScreenDialog: FitHalfScreenDialogV2,
    SvgIcon,
    TncSkeleton,
  },
  props: {
    /** 券信息 */
    couponInfo: {
      type: Object as PropType<ExActAndConfigCouponInfo>,
      required: true,
    },
  },
  setup(prop) {
    // tnc 配置内容
    const tncContent = ref('');
    // tnc 弹窗
    const tncDialog = ref<FitHalfScreenDialogV2 | null>(null);
    // 开启tnc弹窗
    async function showTncDialog() {
      nextTick(() => tncDialog.value?.showDialog());
      // @ts-ignore
      tncContent.value = await getTncConfigContent(prop.couponInfo.couponTandc);
    }
    // 关闭tnc弹窗
    function hideTncDialog() {
      tncDialog.value?.hideDialog();
    }
    return {
      tncDialog,
      tncContent,
      showTncDialog,
      hideTncDialog,
    };
  },
});
